import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  PostsType,
  JournalFilterType,
  PostsSortOrder,
} from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';

import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

const mapStateToProps = (
  state: AppState,
  ownProps: { sortOrder: PostsSortOrder }
) => {
  const journalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    sortOrder: ownProps.sortOrder,
  });
  const featuredJournalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    filter: JournalFilterType.FEATURED,
  });
  const journals = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, journalsStreamId)
  );

  const featuredJournals = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, featuredJournalsStreamId)
  );

  return {
    streamId: journalsStreamId,
    journals,
    featuredJournals,
    hasMoreJournals: streamSelectors.hasMore(state, journalsStreamId),
    hasMoreFeaturedJournals: streamSelectors.hasMore(
      state,
      featuredJournalsStreamId
    ),
    isFetchingJournals: streamSelectors.isFetching(state, journalsStreamId),
    isFetchingFeaturedJournals: streamSelectors.isFetching(
      state,
      featuredJournalsStreamId
    ),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const journalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    sortOrder: ownProps.sortOrder,
  });
  const featuredJournalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    filter: JournalFilterType.FEATURED,
  });
  return {
    fetchMoreJournals: () =>
      dispatch(withOffset.actions.fetch(journalsStreamId)),
    fetchMoreFeaturedJournals: () =>
      dispatch(withOffset.actions.fetch(featuredJournalsStreamId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
